import { get } from "lodash";
import ajaxCall from "./ajaxCall";
import { del } from "vue";
export default {
    login: (email, password) => {
        return ajaxCall.sendPost('/api/login', {
            email: email,
            password: password
        });
    },

    getMe() {
        return ajaxCall.sendGet('/api/me');
    },

    getUserList() {
        return ajaxCall.sendGet('/api/user-list');
    },

    saveUser(dati) {
        return ajaxCall.sendPost('/api/user-save', dati);
    },

    deleteUser(id) {
        return ajaxCall.sendPost('/api/user-delete', { id: id });
    },

    changeshop(shopId) {
        let d = {
            shop_id: shopId
        };

        return ajaxCall.sendPost('/api/change-shop', d);
    },

    uploadShopFile(file, shopId) {
        let d = {
            file: file,
            shop_id: shopId
        }
        return ajaxCall.uploadFile('/api/save-shop-file', d);
    },

    deleteShopFile(shopId) {
        return ajaxCall.sendDelete('/api/save-shop-file/' + shopId);
    },
    searchProduct(filters) {
        return ajaxCall.sendGet('/api/search-products', filters);
    },
    getProduct(codArt) {
        let d = {
            codart: codArt
        };
        return ajaxCall.sendGet('/api/product', d);
    },

    getProductSellStats: (codArt) => {
        let d = {
            codart: codArt
        };
        return ajaxCall.sendGet('/api/product-sell-stats', d);
    },

    getProductList: () => {
        return ajaxCall.sendGet('/api/product-list');
    },

    getProductSell(filters) {
        return ajaxCall.sendGet('/api/product-sell', filters);
    },

    changeProductFlag(prodId, flag) {
        return ajaxCall.sendPost('/api/product-flag', {
            id: prodId,
            flag: flag
        })
    },

    deselectProductFlag() {
        return ajaxCall.sendPost('/deselect-product-flag');
    },

    getSuppliers: (text) => {
        let d = {
            text: text || ""
        }
        return ajaxCall.sendGet('/api/supplier-list', d);
    },
    getSuppliersForRestock: () => {
        return ajaxCall.sendGet('/api/restock/supplier-list');
    },
    getFamilies: () => {
        return ajaxCall.sendGet('/api/family-list');
    },
    getSubFamilies: (familyId) => {
        let d = {
            fid: familyId
        }
        return ajaxCall.sendGet('/api/subfamily-list', d);
    },

    getPointOfSales: () => {
        return ajaxCall.sendGet('/api/pointofsale-list');
    },
    getProductBySupplier(supId, groupId) {
        let d = {
            sup_id: supId,
            group_id: groupId,
        };
        return ajaxCall.sendGet('/api/product-for-restock', d);
    },

    getShopGroupList() {
        return ajaxCall.sendGet('/api/group-list');
    },

    savePercCasamadre(perc) {
        let d = {
            perc_casamadre: perc
        }
        return ajaxCall.sendPost('/api/save-perc-casamadre', d);
    },

    getPercCasamadre() {
        return ajaxCall.sendGet('/api/perc-casamadre');
    },
    getPosField: () => {
        return ajaxCall.sendGet('/api/pos-field');
    },

    getShopifyProductList: (formula) => {
        let d = {
            formula: formula
        }
        return ajaxCall.sendGet('/api/shopify/product-list', d);
    },

    getShopifyCollectionList: () => {
        return ajaxCall.sendGet('/api/shopify/product-collections');
    },
    saveProductToList: (item) => {
        let d = {
            data: item
        }
        return ajaxCall.sendPost('/api/shopify/save-product-to-list', d);
    },
    saveProductCollection: (item) => {
        let d = {
            data: item
        }
        return ajaxCall.sendPost('/api/shopify/save-product-collections', d);
    },
    deleteProduct(shopifyProductId) {
        let d = {
            shopifyProdId: shopifyProductId
        }
        return ajaxCall.sendPost('/api/shopify/delete-product', d);
    },

    exportLinkedData() {
        window.location.href = '/api/shopify/export-linked-data';
    },

    saveProductToListOrder(item) {
        let d = {
            data: item
        }
        return ajaxCall.sendPost('/api/save-product-for-restock', d);
    },

    saveNumOrder(item) {
        let d = {
            ar_codart: item.ar_codart,
            shop_group_id: item.shop_group_id,
            qta_ordinato: item.qta_ordinato,
        }
        return ajaxCall.sendPost('/api/save-num-order', d);
    },

    saveShopGroupData(groupId, supId, data) {
        let d = {
            group_id: groupId,
            sup_id: supId,
            info: data
        }
        return ajaxCall.sendPost('/api/save-shopgroup-data', d);
    },

    getGrupShopSupplierInfo(groupId, supplierId) {
        let d = {
            group_id: groupId,
            sup_id: supplierId
        }
        return ajaxCall.sendGet('/api/group-sup-info', d);
    },

    readProductForRestock(supId) {
        let d = {
            sup_id: supId,
        };
        return ajaxCall.sendGet('/api/read-for-restock', d);
    },

    restockReset(supId) {
        let d = {
            sup_id: supId,
        };
        return ajaxCall.sendPost('/api/restock-reset', d);
    },

    getShopList() {
        let d = {};
        return ajaxCall.sendGet('/api/shop-list', d);
    },

    getListaIncassi(dataIni, shop_id) {
        let d = {
            data_ini: dataIni,
            shop_id: shop_id
        };

        return ajaxCall.sendGet('/api/incassi-list', d);
    },

    saveIncassi(d) {
        return ajaxCall.sendPost('/api/save-incasso', d);
    },

    deleteIncassi(id) {
        let d = {
            id: id
        };
        return ajaxCall.sendPost('/api/delete-incasso', d);
    },

    exportIncassi(dataIni, dataFin, shop_id) {
        let d = {
            data_ini: dataIni,
            data_fin: dataFin,
            shop_id: shop_id
        };
        return ajaxCall.sendGet('/api/incassi-export', d);
    },

    saveShop(data) {
        return ajaxCall.sendPost('/api/save-shop', data);
    },

    getKpi(year, shop_id) {
        let d = {
            year: year,
            shop_id: shop_id
        }
        return ajaxCall.sendGet('/api/kpi', d);
    },

    getIncassiPerAnno(from, to, shopId) {
        let d = {
            from: from,
            to: to,
            shop_id: shopId
        }
        return ajaxCall.sendGet('/api/inscassi-per-anno', d);
    },

    getIncassiPerAnnoTotale(from, type = null, shopIds = []) {
        let d = {
            from: from,
            type: type,
            shop_ids: shopIds
        }
        return ajaxCall.sendGet('/api/inscassi-per-anno-totali', d);
    },

    getMontanti(from, shopId = null) {
        let d = {
            from: from,
            shop_id: shopId
        }
        return ajaxCall.sendGet('/api/montanti', d);
    },

    getMontantiWeek(from, shopId = null) {
        let d = {
            from: from,
            shop_id: shopId
        }
        return ajaxCall.sendGet('/api/montanti-week', d);
    },

    getReportListData(id) {
        let d = {
            id: id
        }
        return ajaxCall.sendGet('/api/report-list-data', d);
    },

    getReportList(d) {
        return ajaxCall.sendGet('/api/report-list', d);
    },

    deleteReportList(id) {
        return ajaxCall.sendGet('/api/report-list-delete/' + id);
    },

    downloadAll() {
        return ajaxCall.sendPost('/api/download-all');
    },

    saveReport(name, reportType, id = null, prodList = []) {
        let d = {
            title: name,
            report_type: reportType,
            id: id,
            prod_list: prodList,
        }
        return ajaxCall.sendPost('/api/save-report', d);
    },

    reportUnselect() {
        let d = {}
        return ajaxCall.sendPost('/api/report-unselect-all', d);
    },

    productRestockAlert(filters) {
        return ajaxCall.sendGet('/api/product-restock-alert', filters);
    },

    productRestockAlertShop(filters) {
        return ajaxCall.sendGet('/api/product-restock-alert-shop', filters);
    },

    getProductRestockShop(filters) {
        return ajaxCall.sendGet('/api/product-restock-shop', filters);
    },
    getTestate(d) {
        return ajaxCall.sendGet('/api/ordini/testate', d);
    },

    getRigheOrdini(codice) {
        let d = {
            codice: codice
        }
        return ajaxCall.sendGet('/api/ordini/righe', d);
    },

    getProductsRating(filters){
        return ajaxCall.sendGet('/api/products/rating', filters);
    },
    getComprehensiveAnalysis(filters){
        return ajaxCall.sendGet('/api/products/comprehensive-analysis', filters);
    },
    getComprehensiveAnalysisExtended(filters){
        return ajaxCall.sendGet('/api/products/comprehensive-analysis-extended', filters);
    },
    getProductsEBITDA(filters){
        return ajaxCall.sendGet('/api/products/ebitda', filters);
    },
    getProductsRESA(filters){
        return ajaxCall.sendGet('/api/products/resa', filters);
    },

    searchProductByBarcode(barcode) {
        let d = {
            barcode: barcode
        }
        return ajaxCall.sendGet('/api/product/search-by-barcode', d);
    },
    restorePasswordReq(email) {
        let d = {
            email: email
        }
        return ajaxCall.sendPost('/api/restore-password-req', d);
    },
    getRacks() {
        return ajaxCall.sendGet('/api/racks/list');
    },

    getRackTypes() {
        return ajaxCall.sendGet('/api/racks/types');
    },

    saveRack(d) {
        return ajaxCall.sendPost('/api/racks/save', d);
    },

    createRackType(name) {
        let d = {
            name: name
        }
        return ajaxCall.sendPost('/api/racks/create-type', d);
    },

    getRack(id) {
        return ajaxCall.sendGet('/api/rack/' + id,);
    },

    deleteRack(id) {
        return ajaxCall.sendDelete('/api/rack/' + id);
    },

    uploadRackFile(file, rackId) {
        let d = {
            file: file,
            rack_id: rackId
        }
        return ajaxCall.uploadFile('/api/racks/upload-file', d);
    },

    deleteRackFile(rackId) {
        return ajaxCall.sendDelete('/api/racks/delete-file/' + rackId);
    },

    getClusterRack(rackId) {
        return ajaxCall.sendGet('/api/rack/' + rackId + '/cluster/list');
    },

    saveClusters(rackId, obj) {
        return ajaxCall.sendPost('/api/rack/' + rackId + '/cluster/save', obj);
    },
    
    importClustersFromCsv(rackId, formData) {
        return ajaxCall.uploadFile('/api/rack/' + rackId + '/cluster/import-csv', formData);
    },
    
    deleteRackCluster(id) {
        return ajaxCall.sendDelete('/api/rack/cluster/' + id);
    },
    createProductType(name) {
        let d = {
            name: name
        }
        return ajaxCall.sendPost('/api/product-type/create', d);
    },

    getProductTypes() {
        return ajaxCall.sendGet('/api/product-types/list');
    },

    copyRack(rackId) {
        return ajaxCall.sendPost('/api/rack/' + rackId + '/copy');
    },

    getRackByShop(shopId) {
        return ajaxCall.sendGet('/api/shop/'+shopId+'/racks');
    },
    createShopMarker(data) {
        return ajaxCall.sendPost('/api/rack/marker', data);
    },
    getPointsByShop(shopId) {
        return ajaxCall.sendGet('/api/shop/'+shopId+'/points');
    },
    getMarkerById(id) {
        return ajaxCall.sendGet('/api/rack/marker/' + id);
    },
    deleteMarker(id) {
        return ajaxCall.sendDelete('/api/rack/marker/' + id);
    },
    getShopRackSell(shopId, filters) {
        return ajaxCall.sendGet('/api/shop/' + shopId + '/rack-sells', filters);
    },

    // Planogram specific functions
    getPlanogramProducts(filters = {}) {
        // Try to use agent API first, fallback to regular search
        return this.searchProduct(Object.assign({ inStock: false }, filters));
    },

    savePlanogram(planogramData) {
        return ajaxCall.sendPost('/api/planogram/save', planogramData);
    },

    loadPlanogram(planogramId) {
        return ajaxCall.sendGet('/api/planogram/' + planogramId);
    },

    deletePlanogram(planogramId) {
        return ajaxCall.sendDelete('/api/planogram/' + planogramId);
    },

    getPlanogramList() {
        return ajaxCall.sendGet('/api/planogram/list');
    },

    exportPlanogram(planogramId, format = 'pdf') {
        let d = {
            format: format
        };
        return ajaxCall.sendGet('/api/planogram/' + planogramId + '/export', d);
    }
}
